import * as React from 'react';
type Props = {
  className?: string;
};
export function Spice({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Spice"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.0157 24.5397C30.1076 21.6666 36.4282 18.5326 36.4282 13.6576C36.4282 8.78215 30.8975 4.29131 20.1046 4.28571C9.3116 4.27972 -1.03285 7.68123 5.7266 12.6386C12.486 17.5963 6.93066 19.6039 4.11399 23.4707C1.29732 27.3376 11.2512 35.6912 20.0326 35.7972C28.814 35.9035 36.4285 32.4716 36.4285 30.1986C36.4285 27.9256 29.9245 27.4127 30.0165 24.5397H30.0157Z"
        fill="#CCE0F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2868 21.8609C19.0674 24.3821 18.0368 26.7067 14.7472 27.8648C13.169 28.4197 12.4127 28.2614 12.3575 28.562C12.1097 29.9172 16.445 31.1876 17.1734 31.3607C19.9181 32.0143 22.6564 31.5318 25.1025 30.0271C27.8264 28.3533 33.3362 21.8173 28.6815 18.8072C26.1546 17.1742 22.9274 19.9976 21.2868 21.8609V21.8609ZM12.9136 22.6028C10.7221 22.6656 8.85846 21.956 7.67758 20.2783C7.46691 19.9781 7.1579 19.5295 7.04597 18.8623C6.77694 17.2489 8.39874 16.7352 8.16728 15.0543C7.71276 11.7403 8.92682 12.2896 9.29859 12.4731C9.86504 12.9432 10.6134 12.8892 10.7909 12.3172C11.8582 8.88326 12.0493 6.91647 13.58 6.66862C15.6295 6.33842 14.487 14.6253 17.0139 12.8972C17.4548 12.5958 18.4518 12.1736 18.5797 12.6186C18.7956 13.3765 18.024 15.1954 17.9009 15.8718C17.737 16.7696 18.092 17.2122 18.1288 17.8226C19.0154 20.4757 16.3331 22.5037 12.9136 22.6028V22.6028Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M29.0431 25.9656C28.1273 21.7518 25.1955 20.469 23.3634 19.9193M29.7987 19.7142C30.431 19.1223 30.9975 18.4637 31.488 17.7498C32.4562 16.3419 32.9731 14.9604 33.2573 13.9694M15.8844 20.0364C15.8628 19.6835 15.6581 19.4276 15.7525 18.9091C15.8244 18.5194 16.2694 17.468 16.145 17.0311C16.0711 16.7741 15.4954 17.0175 15.24 17.1918C13.7809 18.1904 14.4413 13.4041 13.2572 13.5944C12.373 13.7379 12.263 14.8732 11.6466 16.8564C11.5439 17.187 11.1121 17.2178 10.7843 16.9475C10.5705 16.8408 9.86889 16.523 10.1315 18.437C10.2642 19.4084 9.32842 19.705 9.48393 20.6361C9.54829 21.0226 9.72698 21.2805 9.8485 21.4548C10.5301 22.4238 11.6474 22.6392 12.9134 22.6029C14.8882 22.5453 16.3973 21.5683 15.8844 20.0364Z"
        stroke="currentColor"
      />
    </svg>
  );
}
